import { styled } from '@material-ui/styles'

const StyledHookForm = styled('form')(() => ({
  width: '100%',
  margin: '1rem auto',
  background: 'gray',
  '& .form-fields-container': {
    background: 'whitesmoke',
    padding: '0.5rem 0.2rem',
    '& .field': {
      margin: '0.6rem 0px',
    },
    '& .title': {
      background: 'gray',
    },
  },
}))

export default StyledHookForm
